import { memo } from "react";

import { DesignMagazineHotelArticleDefaultEditPresenter } from "./presenter";
import { useHotelArticleQuery } from "../../model/repository/query/use-hotel-query";

type Props = {
	hotelID: string;
};

export const DesignMagazineHotelArticleDefaultEditContainer = memo(({ hotelID }: Props) => {
	const { data } = useHotelArticleQuery({ hotelID });

	if (!data) {
		return null;
	}

	return <DesignMagazineHotelArticleDefaultEditPresenter hotelID={hotelID} data={data} />;
});

DesignMagazineHotelArticleDefaultEditContainer.displayName = "DesignMagazineHotelArticleDefaultEditContainer";
